export enum Severity {
    DEBUG = 1,
    VERBOSE = 2,
    INFO = 3,
    WARNING = 4,
    ERROR = 5,
    CRITICAL = 6
}
